module.exports = __webpack_public_path__ + "img/28200.30e4dd05.jpg";